// extracted by mini-css-extract-plugin
export default {"backToTop":"backtottop_backToTop__51KrU","icon":"backtottop_icon__F-rmH"};